import React, { FC } from 'react';
import { AuthPageWrapper } from '@homeproved/pro/ui';
import { PasswordResetForm } from './PasswordResetForm';

type PasswordResetPageProps = {
  token: string;
  email: string;
};

export const PasswordResetPage: FC<PasswordResetPageProps> = ({ token, email }) => (
  <AuthPageWrapper>
    <PasswordResetForm token={token} email={email} />
  </AuthPageWrapper>
);
